import { useSnapshot } from 'valtio'
import PageWithRadarHeader from '@/components/Radar/PageWithRadarHeader'
import { SafeHtml } from '@/components/SafeHtml/SafeHtml'
import { state } from '@/lib/state'

const HelpAndAboutPage = () => {
  const { radarConfig } = useSnapshot(state)
  const labels = radarConfig?.labels || {}
  const pageTitle = labels.pageAbout
  const aboutContent = labels.pageAboutContent

  // Optionally use radarId for radar-specific help content in the future

  return (
    <PageWithRadarHeader title={pageTitle}>
      <div data-testid="help-about-page" className="space-y-8">
        <div data-testid="help-about-header">
          <h1 className="text-2xl font-bold mb-4">{pageTitle}</h1>
        </div>
        <div data-testid="help-content">
          <section>
            <SafeHtml html={aboutContent} />
          </section>
        </div>
      </div>
    </PageWithRadarHeader>
  )
}

export default HelpAndAboutPage
